import { defineModuleEvidenceContract } from './moduleEvidenceContract';
import { SGA_SPEND_SCHEMA_VERSIONS } from './schemaVersions';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';

const techSoftwareEvidenceEntry =
  SGA_SPEND_MODULE_EVIDENCE_CONTRACT.entries.tech_software;

export const TECH_SOFTWARE_STATE_KEYS = {
  governedSnapshot: techSoftwareEvidenceEntry.stateKey,
  spendAttested: 'tech_software_spend_attested',
  spendGoverned: 'tech_software_spend_governed',
  addressableAttested: 'tech_software_addressable_attested',
  addressableGoverned: 'tech_software_addressable_governed',
  programAttested: 'tech_software_program_attested',
  programGoverned: 'tech_software_program_governed',
  spendSnapshot: 'tech-software-spend-snapshot',
  addressableSnapshot: 'tech-software-addressable-snapshot',
  programSnapshot: 'tech-software-program-snapshot',
} as const;

export const TECH_SOFTWARE_EVIDENCE_KEYS = {
  governedSnapshot: techSoftwareEvidenceEntry.evidenceKey,
  spendSnapshot: TECH_SOFTWARE_STATE_KEYS.spendSnapshot,
  addressableSnapshot: TECH_SOFTWARE_STATE_KEYS.addressableSnapshot,
  programSnapshot: TECH_SOFTWARE_STATE_KEYS.programSnapshot,
} as const;

export const TECH_SOFTWARE_BINDING_PLACEHOLDERS = {
  opportunityUsd: techSoftwareEvidenceEntry.bindingPlaceholders[0],
} as const;

export const TECH_SOFTWARE_SCHEMA_VERSIONS = {
  manifest: SGA_SPEND_SCHEMA_VERSIONS.manifest,
  governedSnapshot: techSoftwareEvidenceEntry.schemaVersion,
} as const;

export const TECH_SOFTWARE_MODULE_EVIDENCE_CONTRACT =
  defineModuleEvidenceContract(
    'tech-software',
    {
      governed_snapshot: techSoftwareEvidenceEntry,
    },
    {
      evidenceKeys: Object.values(TECH_SOFTWARE_EVIDENCE_KEYS),
      sourceClasses: [techSoftwareEvidenceEntry.sourceClass],
      contextKinds: [techSoftwareEvidenceEntry.contextKind],
      schemaVersions: Object.values(TECH_SOFTWARE_SCHEMA_VERSIONS),
      stateKeys: Object.values(TECH_SOFTWARE_STATE_KEYS),
      bindingPlaceholders: Object.values(TECH_SOFTWARE_BINDING_PLACEHOLDERS),
    },
  );

export type TechSoftwareModuleEvidenceContract =
  typeof TECH_SOFTWARE_MODULE_EVIDENCE_CONTRACT;
